import { ReactNode } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { Cormorant_Garamond } from 'next/font/google';
import { toAbsoluteUrl } from '@/lib/helpers';
import { Card, CardContent } from '@/components/ui/card';

const cormorant = Cormorant_Garamond({
  subsets: ['latin'],
  weight: ['400', '600'],
});

export function BrandedLayout({ children }: { children: ReactNode }) {
  return (
    <>
      <style>
        {`
          .branded-bg {
            background:
              linear-gradient(rgba(15,10,6,0.55), rgba(15,10,6,0.7)),
              url('${toAbsoluteUrl('/media/app/auth-bg.jpg')}') center/cover no-repeat;
          }
        `}
      </style>
      <div className="grid lg:grid-cols-2 grow">
        {/* Login form — left on desktop */}
        <div className="flex justify-center items-center p-8 lg:p-10 order-2 lg:order-1">
          <Card className="w-full max-w-[400px]">
            <CardContent className="p-6">{children}</CardContent>
          </Card>
        </div>

        {/* Decorative photo panel — right on desktop */}
        <div className="lg:rounded-xl lg:m-5 order-1 lg:order-2 branded-bg relative flex flex-col">
          <div className="flex flex-col items-center justify-center text-center grow p-8 lg:p-16 gap-6">
            <Link href="/">
              <Image
                src="/images/ozclub-logo-white.png"
                alt="Oz Club"
                height={48}
                width={360}
                style={{ objectFit: 'contain' }}
              />
            </Link>
            <div
              className="w-10 h-[2px]"
              style={{ backgroundColor: '#6B1F2A' }}
            />
            <div className="flex flex-col gap-3 max-w-[420px]">
              <h3
                className={`${cormorant.className} text-3xl lg:text-4xl font-semibold`}
                style={{ color: '#FAF6F0' }}
              >
                Wizards of Vine
              </h3>
              <p
                className="text-base font-medium"
                style={{ color: 'rgba(250,246,240,0.8)' }}
              >
                The wine platform connecting Occitanie&apos;s finest châteaux
                with restaurants and wine lovers.
              </p>
            </div>
          </div>
          <p
            className="text-center text-xs pb-6"
            style={{ color: 'rgba(250,246,240,0.55)' }}
          >
            © 2026 Oz Club · Occitanie, France
          </p>
        </div>
      </div>
    </>
  );
}
